import type { CustomerMessage, MessageFilter } from "./api";
import type { SortColumn } from "./sort";

export const MESSAGE_FILTERS: readonly { value: MessageFilter; label: string }[] = [
  { value: "open", label: "Open" },
  { value: "done", label: "Done" },
  { value: "all", label: "All" },
];

export const STATUS_TEXT: Record<CustomerMessage["status"], string> = { open: "Open", done: "Done" };

export function readMessageFilter(search: string): MessageFilter {
  const value = new URLSearchParams(search).get("status");
  return MESSAGE_FILTERS.some((filter) => filter.value === value) ? (value as MessageFilter) : "open";
}

export const messageCount = (count: number) => (count === 1 ? "1 message" : `${count} messages`);

/** The ids of the shown messages that the user can change to the status. */
export const changeIds = (messages: readonly CustomerMessage[], to: CustomerMessage["status"]) =>
  messages.filter((message) => message.can_edit && message.status !== to).map((message) => message.id);

export function changedText(to: CustomerMessage["status"], changed: number, unchanged: number): string {
  const done = `${to === "done" ? "Marked done" : "Opened again"}: ${messageCount(changed)}.`;
  return unchanged ? `${done} ${unchanged} had that status already.` : done;
}

export const MESSAGE_COLUMNS: SortColumn<CustomerMessage>[] = [
  { key: "account", label: "Account", value: (m) => m.account_number },
  { key: "sent", label: "Sent", value: (m) => m.sent_at, first: "desc" },
  { key: "location", label: "Location", value: (m) => m.location },
  { key: "from", label: "From", value: (m) => m.from_email },
  { key: "message", label: "Message", value: (m) => m.text },
  { key: "status", label: "Status", value: (m) => m.status, order: ["open", "done"] },
  { key: "done", label: "Done by", value: (m) => m.done_by },
];
